import type React from 'react';
import { useRef } from 'react';
import { Paragraph } from '../../../components';
import { Icons } from '../../icon/icons';
import './blockSourceButton.less';
import { useDrag } from 'react-dnd';

const { IcoDrag, IcoTextbox } = Icons;

interface TextBlockButtonProps {
  title: string;
  onClickAdd?: () => void;
}

const TextBlockButton: React.FunctionComponent<TextBlockButtonProps> = ({ title, onClickAdd }) => {
  const wasDraggingRef = useRef(false);
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'TEXT',
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    item: () => {
      wasDraggingRef.current = true;
      return {};
    },
    end: () => {
      requestAnimationFrame(() => {
        wasDraggingRef.current = false;
      });
    },
  }));

  const handleClick = () => {
    if (wasDraggingRef.current) return;
    onClickAdd?.();
  };

  return (
    <button ref={drag} draggable className="block-source" style={{ opacity: isDragging ? 0.5 : 1 }} onClick={handleClick}>
      <div className="block-source-icon">
        <IcoTextbox />
      </div>
      <div className="block-source-drag-icon">
        <IcoDrag />
      </div>
      <Paragraph size="sm">{title}</Paragraph>
    </button>
  );
};

export default TextBlockButton;
TextBlockButton.displayName = 'TextBlockButton';
